export default __webpack_public_path__ + "static/media/evenlay.2c729257.png";